export default "__VITE_ASSET__cZg1bWAG__"